import _ from "lodash";
import { useCalculations, } from "./useCalculations";
import moment from "moment";
var COMPARE;
(function (COMPARE) {
    COMPARE[COMPARE["MIN"] = 0] = "MIN";
    COMPARE[COMPARE["MAX"] = 1] = "MAX";
})(COMPARE || (COMPARE = {}));
const DeliveryTypeCheck = (requirement, postalCode) => {
    let passedRequirement = false;
    if (requirement) {
        switch (requirement) {
            case "pickup":
                passedRequirement = !postalCode;
                break;
            case "delivery":
                passedRequirement = Boolean(postalCode);
                break;
            case "deliveryAndPickup":
                passedRequirement = true;
                break;
            default:
                passedRequirement = false;
                break;
        }
        return passedRequirement;
    }
    else {
        return true; //deliveryType is N/A
    }
};
const MinMealsPerDayCheck = (GenerateResponse, GetMealDays, GetMealsPerDay, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let mealsPerDayRequirement = parseInt(requirement.NumericValue);
        if (mealsPerDayRequirement >= 0) {
            if (!meals || (meals && !meals.length)) {
                return GenerateResponse(false, requirement);
            }
            GetMealDays(meals).forEach((mealDay) => {
                if (requirementsResponse !== null) {
                    return;
                }
                if (GetMealsPerDay(meals, mealDay) < mealsPerDayRequirement) {
                    requirementsResponse = GenerateResponse(false, requirement);
                }
            });
        }
    }
    return requirementsResponse;
};
const MaxMealsPerDayCheck = (GenerateResponse, GetMealDays, GetMealsPerDay, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let mealsPerDayRequirement = parseInt(requirement.NumericValue);
        if (mealsPerDayRequirement >= 0) {
            GetMealDays(meals).forEach((mealDay) => {
                if (requirementsResponse !== null) {
                    return;
                }
                if (GetMealsPerDay(meals, mealDay) > mealsPerDayRequirement) {
                    requirementsResponse = GenerateResponse(false, requirement);
                }
            });
        }
    }
    return requirementsResponse;
};
const MinMealsPerOrderCheck = (GenerateResponse, GetMealsPerOrder, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let mealsPerOrderRequirement = parseInt(requirement.NumericValue);
        if (mealsPerOrderRequirement >= 0) {
            if (GetMealsPerOrder(meals) < mealsPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const MaxMealsPerOrderCheck = (GenerateResponse, GetMealsPerOrder, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let mealsPerOrderRequirement = parseInt(requirement.NumericValue);
        if (mealsPerOrderRequirement >= 0) {
            if (GetMealsPerOrder(meals) > mealsPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const MinDaysPerOrderCheck = (GenerateResponse, GetMealDays, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let daysPerOrderRequirement = parseInt(requirement.NumericValue);
        if (daysPerOrderRequirement > 0) {
            if (GetMealDays(meals).length < daysPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const MinAmountPerDayCheck = (GenerateResponse, GetMealDays, GetProductDays, getTotalAmountForDay, getTotalProductAmountPerDay, requirement, skipPayment, meals, products) => {
    let requirementsResponse = null;
    const orderHasMeals = meals && meals.length;
    const orderHasProducts = products && products.length;
    if (requirement && !skipPayment) {
        const amountPerDayRequirement = parseInt(requirement.NumericValue);
        if (amountPerDayRequirement >= 0) {
            if (orderHasMeals) {
                GetMealDays(meals).forEach((mealDay) => {
                    if (requirementsResponse !== null) {
                        return;
                    }
                    if (getTotalAmountForDay(meals, products, mealDay) < amountPerDayRequirement) {
                        requirementsResponse = GenerateResponse(false, requirement);
                    }
                });
            }
            else if (orderHasProducts) {
                GetProductDays(products).forEach((day) => {
                    if (requirementsResponse !== null) {
                        return;
                    }
                    if (getTotalProductAmountPerDay(products, day) < amountPerDayRequirement) {
                        requirementsResponse = GenerateResponse(false, requirement);
                    }
                });
            }
            else {
                return GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const MinAmountPerOrderCheck = (GenerateResponse, getTotalAmountForOrder, requirement, skipPayment, meals, products, programMeals) => {
    let requirementsResponse = null;
    if (requirement && !skipPayment) {
        let amountPerOrderRequirement = parseInt(requirement.NumericValue);
        if (amountPerOrderRequirement >= 0) {
            if (getTotalAmountForOrder(meals, products, programMeals) < amountPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const SubscriptionDaysPerOrderChecks = (GenerateResponse, requirement, daysOfWeek, cart, comparison_type) => {
    let requirementsResponse = null;
    if (requirement && cart.isSubscription) {
        let daysPerOrderRequirement = parseInt(requirement.NumericValue);
        if (daysPerOrderRequirement >= 0) {
            if ((comparison_type == COMPARE.MIN && daysOfWeek.length < daysPerOrderRequirement) ||
                (comparison_type == COMPARE.MAX && daysOfWeek.length > daysPerOrderRequirement)) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const SubscriptionMealsPerOrderChecks = (GenerateResponse, GetSubscriptionMealsForOrder, requirement, cart, comparison_type) => {
    let requirementsResponse = null;
    let subscriptionMealsQty = 0;
    if (requirement && cart.isSubscription) {
        let mealsPerOrderRequirement = parseInt(requirement.NumericValue);
        if (mealsPerOrderRequirement >= 0) {
            let subscriptionMeals = GetSubscriptionMealsForOrder();
            subscriptionMeals.forEach((subscriptionMealDay) => {
                subscriptionMealsQty += subscriptionMealDay.Qty;
            });
            if ((comparison_type == COMPARE.MIN && subscriptionMealsQty < mealsPerOrderRequirement) ||
                (comparison_type == COMPARE.MAX && subscriptionMealsQty > mealsPerOrderRequirement)) {
                console.error(requirement.ErrorMsg);
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const SubscriptionMealsPerDayChecks = (GenerateResponse, GetSubscriptionMealsForOrder, requirement, model, cart, comparison_type) => {
    let requirementsResponse = null;
    if (requirement) {
        let mealsPerDayRequirement = parseInt(requirement.NumericValue);
        if (mealsPerDayRequirement >= 0) {
            let subscriptionMeals = GetSubscriptionMealsForOrder();
            if (!subscriptionMeals || (subscriptionMeals && !subscriptionMeals.length)) {
                return GenerateResponse(false, requirement);
            }
            var subscriptionDays = [...new Set(subscriptionMeals.map((subMeal) => subMeal.DayOfWeek))];
            subscriptionDays.forEach((day) => {
                if (requirementsResponse !== null) {
                    return;
                }
                var mealsPerDay = _.sumBy(subscriptionMeals.filter((subDay) => subDay.DayOfWeek == day), function (o) {
                    return o.Qty;
                });
                if ((comparison_type == COMPARE.MIN && mealsPerDay < mealsPerDayRequirement) ||
                    (comparison_type == COMPARE.MAX && mealsPerDay > mealsPerDayRequirement)) {
                    requirementsResponse = GenerateResponse(false, requirement);
                }
            });
        }
    }
    return requirementsResponse;
};
const isRecipeTypeSelectedCheck = (GenerateResponse, requirement, cart) => {
    let requirementResponse = null;
    if (requirement && !cart.recipeType) {
        requirementResponse = GenerateResponse(false, requirement);
    }
    return requirementResponse;
};
//Currently not being used but leaving for future implementation
const MaxAmountPerDayCheck = (GenerateResponse, GetMealDays, getTotalAmountForDay, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let amountPerDayRequirement = parseInt(requirement.NumericValue);
        if (amountPerDayRequirement >= 0) {
            GetMealDays(meals).forEach((mealDay) => {
                if (requirementsResponse !== null) {
                    return;
                }
                if (getTotalAmountForDay(meals, mealDay) > amountPerDayRequirement) {
                    requirementsResponse = GenerateResponse(false, requirement);
                }
            });
        }
    }
    return requirementsResponse;
};
const MaxAmountPerOrderCheck = (GenerateResponse, getTotalAmountForOrder, requirement, meals, products) => {
    let requirementsResponse = null;
    if (requirement) {
        let amountPerOrderRequirement = parseInt(requirement.NumericValue);
        if (amountPerOrderRequirement >= 0) {
            if (getTotalAmountForOrder(meals, products) > amountPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const MaxDaysPerOrderCheck = (GenerateResponse, GetMealDays, requirement, meals) => {
    let requirementsResponse = null;
    if (requirement) {
        let daysPerOrderRequirement = parseInt(requirement.NumericValue);
        if (daysPerOrderRequirement > 0) {
            if (GetMealDays(meals).length > daysPerOrderRequirement) {
                requirementsResponse = GenerateResponse(false, requirement);
            }
        }
    }
    return requirementsResponse;
};
const CheckRequirements = (GenerateResponse, GetMealDays, getProductDays, GetMealsPerOrder, GetMealsPerDay, getTotalAmountForDay, getTotalProductAmountPerDay, getTotalAmountForOrder, GetSubscriptionMealsForOrder) => (requirements, skipPayment, meals, products, postalCode, currentPage, daysOfWeek, model, cart) => {
    let requirementsResponse = null;
    requirements.forEach((requirementObject) => {
        if (requirementObject.page <= currentPage) {
            if (requirementsResponse !== null) {
                return;
            }
            let requirement = requirementObject.moduleConfig;
            if (!DeliveryTypeCheck(requirement.DeliveryMethod, postalCode)) {
                return;
            }
            requirementsResponse = MinMealsPerDayCheck(GenerateResponse, GetMealDays, GetMealsPerDay, requirement.MinMealsPerDay, meals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MaxMealsPerDayCheck(GenerateResponse, GetMealDays, GetMealsPerDay, requirement.MaxMealsPerDay, meals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MinMealsPerOrderCheck(GenerateResponse, GetMealsPerOrder, requirement.MinMealsPerOrder, meals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MaxMealsPerOrderCheck(GenerateResponse, GetMealsPerOrder, requirement.MaxMealsPerOrder, meals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MinDaysPerOrderCheck(GenerateResponse, GetMealDays, requirement.MinDaysPerOrder, meals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MinAmountPerDayCheck(GenerateResponse, GetMealDays, getProductDays, getTotalAmountForDay, getTotalProductAmountPerDay, requirement.MinAmountPerDay, skipPayment, meals, products.filter((p) => p.quantity > 0 && p.DayOfWeek >= moment(cart.startDate).weekday()));
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = MinAmountPerOrderCheck(GenerateResponse, getTotalAmountForOrder, requirement.MinAmountPerOrder, skipPayment, meals, products.filter((p) => p.quantity > 0 && p.DayOfWeek >= moment(cart.startDate).weekday()), model.Program.ProgramMeals);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionMealsPerOrderChecks(GenerateResponse, GetSubscriptionMealsForOrder, requirement.MinSubscriptionMealsPerOrder, cart, COMPARE.MIN);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionMealsPerOrderChecks(GenerateResponse, GetSubscriptionMealsForOrder, requirement.MaxSubscriptionMealsPerOrder, cart, COMPARE.MAX);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionDaysPerOrderChecks(GenerateResponse, requirement.MinSubscriptionDaysPerOrder, daysOfWeek, cart, COMPARE.MIN);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionDaysPerOrderChecks(GenerateResponse, requirement.MaxSubscriptionDaysPerOrder, daysOfWeek, cart, COMPARE.MAX);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionMealsPerDayChecks(GenerateResponse, GetSubscriptionMealsForOrder, requirement.MinSubscriptionMealsPerDay, model, cart, COMPARE.MIN);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = SubscriptionMealsPerDayChecks(GenerateResponse, GetSubscriptionMealsForOrder, requirement.MaxSubscriptionMealsPerDay, model, cart, COMPARE.MAX);
            if (requirementsResponse !== null) {
                return;
            }
            requirementsResponse = isRecipeTypeSelectedCheck(GenerateResponse, requirement.EnforceRecipeTypeSelection, cart);
            if (requirementsResponse !== null) {
                return;
            }
        }
    });
    if (requirementsResponse == null) {
        //successfully passed all requirements
        return GenerateResponse(true, null);
    }
    return requirementsResponse;
};
/**
 *
 */
export const useCheckRequirements = () => {
    const { GenerateResponse, GetMealDays, GetProductDays, GetMealsPerOrder, GetMealsPerDay, getTotalAmountForDay, getTotalProductAmountPerDay, getTotalAmountForOrder, GetSubscriptionMealsForOrder, } = useCalculations();
    return {
        CheckRequirements: CheckRequirements(GenerateResponse, GetMealDays, GetProductDays, GetMealsPerOrder, GetMealsPerDay, getTotalAmountForDay, getTotalProductAmountPerDay, getTotalAmountForOrder, GetSubscriptionMealsForOrder),
    };
};
